import '@atlaskit/css-reset'
import { colors, typography, gridSize, fontFamily } from '@atlaskit/theme'
import { Global, css } from '@emotion/react'
import React from 'react'
import fonts from '../fonts'
import analytics from '../services/analytics'
import Footer from './Footer'
import Header from './Header'

const akGridSize = gridSize()
const akFontFamily = fontFamily()

export default function Layout({ children }) {
  React.useEffect(() => {
    analytics.events.viewed()
  }, [])

  return (
    <>
      <Global
        styles={css`
          @font-face {
            font-family: 'Charlie Display';
            src: url(${fonts.CharlieDisplaySemiBold});
            font-weight: 500;
            font-display: swap;
          }

          @font-face {
            font-family: 'Charlie Display';
            src: url(${fonts.CharlieDisplayRegular});
            font-weight: 400;
            font-display: swap;
          }

          @font-face {
            font-family: 'Charlie Display';
            src: url(${fonts.CharlieDisplayThin});
            font-weight: 100;
            font-display: swap;
          }

          @font-face {
            font-family: 'Charlie Text';
            src: url(${fonts.CharlieTextRegular});
            font-weight: 400;
            font-display: swap;
          }

          .page {
            &-header,
            &-footer {
              background-color: ${colors.skeleton()};

              & div {
                display: flex;
                align-items: center;
                height: ${9 * akGridSize}px;
                margin: auto;
                max-width: ${145 * akGridSize}px;
              }
            }
          }

          footer div {
            flex-wrap: wrap;
            justify-content: center;
          }

          main {
            background-color: ${colors.background()};
            flex-grow: 1;
          }

          h1,
          h2,
          h3,
          h4 {
            color: ${colors.heading()};
            font-family: 'Charlie Display', ${akFontFamily};
            margin-bottom: ${2 * akGridSize}px;
          }

          h1 {
            font-size: 44px;
            line-height: 52px;
            font-weight: 500;
          }

          h2 {
            font-size: ${typography.headingSizes.h900.size}px;
            line-height: ${typography.headingSizes.h900.lineHeight}px;
            font-weight: 500;
          }

          h3 {
            font-size: ${typography.headingSizes.h900.size}px;
            line-height: ${typography.headingSizes.h700.lineHeight}px;
            letter-spacing: 0.3px;
          }

          h4 {
            font-size: ${typography.headingSizes.h600.size}px;
            line-height: ${typography.headingSizes.h600.lineHeight}px;
            font-weight: 600;
          }

          p,
          span {
            font-family: 'Charlie Text', ${akFontFamily};
          }

          p {
            font-size: ${typography.headingSizes.h500.size}px;
          }

          span {
            font-size: ${typography.headingSizes.h400.size}px;
          }

          hr {
            background-color: ${colors.N40};
            border: none;
            height: 2px;
          }

          .dialog-section {
            background-color: ${colors.primary()};
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
          }

          @media screen and (max-width: 640px) {
            h1 {
              font-size: ${typography.headingSizes.h800.size}px;
              line-height: ${typography.headingSizes.h900.lineHeight}px;
            }

            h2,
            h3 {
              font-size: ${typography.headingSizes.h700.size}px;
              line-height: ${typography.headingSizes.h800.lineHeight}px;
            }

            h4 {
              font-size: ${typography.headingSizes.h500.size}px;
              line-height: ${typography.headingSizes.h600.lineHeight}px;
            }
          }

          @media screen and (max-width: 768px) {
            header div {
              justify-content: center;
            }
          }
        `}
      />
      <div
        css={css`
          display: flex;
          flex-direction: column;
          min-height: 100vh;
        `}
      >
        <Header />
        <main>{children}</main>
        <Footer />
      </div>
    </>
  )
}
